module.exports = __webpack_public_path__ + "img/c521b45.png";